// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body[data-page-id="volumeCollectionView"] {
	padding-bottom: 0;
}


.volume-collection-list {
	height: calc(100vh - 280px);
    overflow: auto;
}`, "",{"version":3,"sources":["webpack://./src/views/volumeCollection/style.css"],"names":[],"mappings":"AAAA;CACC,iBAAiB;AAClB;;;AAGA;CACC,2BAA2B;IACxB,cAAc;AAClB","sourcesContent":["body[data-page-id=\"volumeCollectionView\"] {\r\n\tpadding-bottom: 0;\r\n}\r\n\r\n\r\n.volume-collection-list {\r\n\theight: calc(100vh - 280px);\r\n    overflow: auto;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
